import {
    LOCATION_FAILED_2,
    LOCATION_FETCHING_2,
    LOCATION_PROVINCE_SUCCESS_2,
    LOCATION_DISTRICT_SUCCESS_2,
    LOCATION_SUBDISTRICT_SUCCESS_2,
    LOCATION_MOO_SUCCESS_2,
    LOCATION_COMMUNITY_SUCCESS_2
} from "../../Constants.ts";

export interface LOCATION2State {
    isFetching: boolean;
    isError: boolean;
    province: any | null;
    district: { data: [] };
    subDistrict: { data: [] };
    moo: { data: [] };
    community: { data: [] },

}

const initialState: LOCATION2State = {
    isFetching: false,
    isError: false,
    province: null,
    district: { data: [] },
    subDistrict: { data: [] },
    moo: { data: [] },
    community: { data: [] },
};

export default (state = initialState, { type, payload }: any): LOCATION2State => {
    switch (type) {
        case LOCATION_FETCHING_2:
            return { ...state, isFetching: true, isError: false };
        case LOCATION_PROVINCE_SUCCESS_2:
            return { ...state, isFetching: false, isError: false, province: payload };
        case LOCATION_SUBDISTRICT_SUCCESS_2:
            return { ...state, isFetching: false, isError: false, subDistrict: payload };
        case LOCATION_DISTRICT_SUCCESS_2:
            return { ...state, isFetching: false, isError: false, district: payload };
        case LOCATION_MOO_SUCCESS_2:
            return { ...state, isFetching: false, isError: false, moo: payload };
        case LOCATION_COMMUNITY_SUCCESS_2:
            return { ...state, isFetching: false, isError: false, community: payload };
        case LOCATION_FAILED_2:
            return { ...state, isFetching: false, isError: true };
        default:
            return state;
    }
};
